var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customReportId)?_c('CustomReportTable',{attrs:{"customReportId":_vm.customReportId},on:{"name":_vm.setName}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }